import { Geschlecht } from '@/types/Geschlecht';
import { Satzart } from '@/types/Satzart';
import { Teilimpfungsart } from '@/types/Teilimpfungsart';
import { Vue } from 'vue-property-decorator';

export default class Impferinnerung {
    public patimpfung_id: string | number | null = null;
    public patnr: string | null = null;
    public satzart: number | null = null;
    public nachtrag: string | null = null;
    public elga: string | null = null;
    public storniert: string | null = null;
    public eimpf_transfer: string | null = null;
    public eimpf_id: string | null = null;
    public eimpf_system: string | null = null;
    public impfungindikation_code: string | null = null;
    public impfschema_code: string | null = null;
    public impfstoff_code: string | null = null;
    public impfstoff_id: string | null = null;
    public impfstoff: string | null = null;
    public impfung_code: string | null = null;
    public impfung: string | null = null;
    public impfdatum: string | null = null;
    public impfdosis_code: string | null = null;
    public teilimpfungsnr: Teilimpfungsart | string | null = null;
    public naechstesimpfdatum: string | null = null;
    public naechsteteilimpfungsnr: number | null = null;
    public erinnert: string | null = null;
    public erinnerung_gesendet: string | null = null;
    public impfstelle_id: string | null = null;
    public arzt: string | null = null;
    public person_id_durchf: string | null = null;
    public nachname: string | null = null;
    public vorname: string | null = null;
    public titel: string | null = null;
    public titel_nach_name: string | null = null;
    public geschlecht: Geschlecht | null = null;
    public strasse: string | null = null;
    public plz: string | null = null;
    public ort: string | null = null;
    public email: string | null = null;
    public telefon: string | null = null;
    public impfstoff_impfung: string | null = null;
    public impfstoff_impfstoff: string | null = null;
    public bezeichnung: string | null = null;
    public elga_impfstoff_code: string | null = null;

    public get display(): { [satzart: number]: (eintrag: Impferinnerung) => string | null } {
        return {
            [Satzart.Impfung]: (eintrag: Impferinnerung): string | null => {
                return eintrag.teilimpfungsKuerzel + eintrag.impfungsText;
            },
        };
    }

    public get impfungsText(): string {
        if (this.impfstoff_id) {
            return `${this.impfstoff_impfung} (${this.bezeichnung})`;
        }

        if (this.impfung) {
            if (this.impfstoff) {
                return `${this.impfung} (${this.impfstoff})`;
            }

            return this.impfung;
        }

        return '';
    }

    public get teilimpfungsKuerzel(): string {
        if (this.teilimpfungsnr !== null) {
            if (this.isAuffrischung) {
                return 'A. ';
            }

            if (this.isTeilimpfung) {
                return this.teilimpfungsnr + '. ';
            }
        }

        return '';
    }

    public get teilimpfungsText(): string {
        if (this.teilimpfungsnr !== null) {
            if (this.isAuffrischung) {
                return 'Auffrischung';
            }

            if (this.isTeilimpfung) {
                return this.teilimpfungsnr + '. Teilimpfung';
            }
        }

        return '';
    }

    public get isEinfachimpfung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Einfachimpfung;
    }

    public get isTeilimpfung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Teilimpfung1 ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung2 ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung3 ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung4;
    }

    public get isAuffrischung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Auffrischung ||
            this.teilimpfungsnr === Teilimpfungsart.AuffrischungsSerieTeil1 ||
            this.teilimpfungsnr === Teilimpfungsart.AuffrischungsSerieTeil2;
    }

    public get textDisplay(): string {
        return this.satzart !== null ? this.display[this.satzart](this) ?? '' : '';
    }

    public get impfdatumDisplay(): string {
        return Vue.prototype.$d(this.impfdatum);
    }

    public get naechstesimpfdatumDisplay(): string {
        return Vue.prototype.$d(this.naechstesimpfdatum);
    }

    constructor(data?: Partial<Impferinnerung>) {
        Object.assign(this, data);

        this.patimpfung_id = typeof data?.patimpfung_id === 'string'
            ? parseInt(data?.patimpfung_id, 0) as number
            : data?.patimpfung_id as number;

        this.teilimpfungsnr = typeof data?.teilimpfungsnr === 'string'
            ? parseInt(data?.teilimpfungsnr, 0) as Teilimpfungsart
            : data?.teilimpfungsnr as Teilimpfungsart;
    }
}
